import {WidgetConfig} from "types/config";
import {ChatWidget} from "classes/chat/chatWidget";
import {Alpine as AlpineNamespace} from "@alpinejs/csp";
import AlpineMagics = AlpineNamespace.Magics;

import AlpineComponent = AlpineNamespace.AlpineComponent;

type UsernameFormFactory = (widget: ChatWidget, widgetConfig: WidgetConfig) => AlpineComponent<IUsernameForm>;
type ValidationError = {
    [key: string]: string;
}

export interface IUsernameForm {
    readonly usernameSubHeader: string;
    readonly placeholderFirstname: string;
    readonly placeholderLastname: string;


    gender: string;
    firstname: string;
    isAgreementChecked: boolean;
    lastname: string;

    validationErrors: ValidationError;

    submitForm(): void;
}

class UsernameForm implements IUsernameForm {
    readonly usernameSubHeader: string;
    readonly placeholderFirstname: string;
    readonly placeholderLastname: string;

    constructor(private widget: ChatWidget, private widgetConfig: WidgetConfig) {
        this.usernameSubHeader = this.widgetConfig.getUsernameSubHeaderText();
        this.placeholderFirstname = this.widgetConfig.getFirstnamePlaceholder();
        this.placeholderLastname = this.widgetConfig.getLastnamePlaceholder();
    }

    public gender: string = '';
    public firstname: string = '';
    public isAgreementChecked: boolean = false;
    public lastname: string = '';

    public validationErrors: ValidationError = {};

    public submitForm(): void {
        this.clearValidationErrors();
        this.handleUsernameForm();
    }

    private clearValidationErrors(): void {
        this.validationErrors = {};
    }

    private async handleUsernameForm(): Promise<void>
    {
        this.firstname = this.firstname.trim();
        this.lastname = this.lastname.trim();

        if(!this.validate()) {
            return;
        }

        this.widget.setUserData(this.firstname, this.lastname, 0, '', '', this.gender);
        this.widget.initMessagesContent();
        await this.usernameFormComponent.$nextTick();

        // this.usernameFormComponent.$dispatch('switch-to-agent-chat');
        window.dispatchEvent(new CustomEvent("switch-to-agent-chat"));
        this.widget.initChat();
    }

    private validate(): boolean
    {
        if (!this.isAgreementChecked) {
            this.addValidationError('agreement', this.widgetConfig.getAgreementError());
        }

        if (this.lastname === '') {
            this.addValidationError('lastname', this.widgetConfig.getLastnameError());
        }

        return Object.keys(this.validationErrors).length === 0;
    }

    private addValidationError(type: string, errorDescription: string): void {
        this.validationErrors[type] = errorDescription;
    }

    private get usernameFormComponent(): AlpineMagics<this> {
        return this as unknown as AlpineMagics<this>;
    }
}

const usernameForm: UsernameFormFactory = function(widget: ChatWidget, widgetConfig: WidgetConfig) {
    return new UsernameForm(widget, widgetConfig) as AlpineComponent<UsernameForm>;
};

export default usernameForm;